<template>
  <div class="app">
    <Nav />
    <div class="app-body">
      <div :class="{ container: !noContainer }">
        <router-view />
      </div>
    </div>
    <Footer />
    <el-backtop :bottom="100" :right="40">
      <div
        style="{
        height:60px;
        width: 60px;
        background-color: #00BDB7;
        text-align: center;
         vertical-align:middle;
        color: #1989fa;
      }"
      >
        <img
          src="../assets/img/top.png"
          style="height:40px;
        width: 40px; vertical-align:middle;"
        />
      </div>
    </el-backtop>
  </div>
</template>

<script>
import Nav from './nav';
import Footer from './footer';
export default {
  name: 'Layout',
  components: {
    Nav,
    Footer
  },
  data() {
    return {
      noContainer: false
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.setContainer(to.meta.noContainer);
    next();
  },
  mounted() {
    this.setContainer(this.$route.meta.noContainer);
  },
  methods: {
    setContainer(value) {
      this.noContainer = value;
    }
  }
};
</script>
<style>
.app-body {
  /* padding-bottom: 480px; */
}
</style>



// WEBPACK FOOTER //
// src/layout/Index.vue